import React from "react";
import { Sparkles, Check, AlertTriangle, Ban } from "lucide-react";
import { CAMERA_COACH_STYLES } from "@/lib/cameraLiveCheck";

/** Kiegészítő-sor stílusú AI visszajelzés (kamera / 360 videó). */
export function CameraCoachBar({ ui, className = "" }) {
  if (!ui) return null;
  const coachStyle = CAMERA_COACH_STYLES[ui.tone] || CAMERA_COACH_STYLES.neutral;
  const CoachIcon =
    ui.tone === "ok" ? Check
      : ui.tone === "block" ? Ban
        : ui.tone === "warn" ? AlertTriangle
          : Sparkles;

  return (
    <div
      data-testid={ui.testId || "camera-ai-coach"}
      className={`flex items-start justify-between gap-3 py-2.5 px-3 rounded-lg border backdrop-blur-sm ${coachStyle.box} ${className}`}
    >
      <div className="flex items-start gap-2.5 min-w-0 flex-1 text-left">
        <CoachIcon className={`w-3.5 h-3.5 shrink-0 mt-0.5 ${coachStyle.icon}`} strokeWidth={1.75} />
        <div className="min-w-0">
          <div className={`text-xs font-medium leading-snug ${coachStyle.title}`}>{ui.car}</div>
          {ui.light ? (
            <div className={`text-[10px] uppercase tracking-[0.12em] mt-0.5 ${coachStyle.light}`}>
              Fény · {ui.light}
            </div>
          ) : null}
          {ui.detail ? (
            <div className={`text-[11px] mt-1 leading-relaxed ${coachStyle.detail}`}>{ui.detail}</div>
          ) : null}
        </div>
      </div>
      {ui.badge ? (
        <span className={`shrink-0 text-[10px] uppercase tracking-[0.15em] font-medium pt-0.5 ${coachStyle.badge}`}>
          {ui.badge}
        </span>
      ) : null}
    </div>
  );
}
